import { SuggestedSearchResponse } from "@api-types/suggested-search";
import { getCurrentLanguage, httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

export default class PlatformOfferApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/offer`;
	}

	static getRequestHeaders = (context: ApiRequestContextData) => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		appHeaders["Accept" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getSuggestedSearch(): Promise<SuggestedSearchResponse> {
		const context = getApiRequestContext();

		return httpClient.get(
			`${this.baseUrl}/suggested-search?language=${getCurrentLanguage()}`,
			this.getRequestHeaders(context)
		);
	}
}
